import { Provider } from "@angular/core";
import { PlanSetProgramService } from "./services/plan-set-program.service";

export const PlanSetProgramProviders: Provider[] = [
  PlanSetProgramService
]
